module.exports = __webpack_public_path__ + "img/favicon.fd0c1b15.png";